import { render, staticRenderFns } from "./ProgressLegend.vue?vue&type=template&id=7bf72344&scoped=true"
import script from "./ProgressLegend.vue?vue&type=script&lang=js"
export * from "./ProgressLegend.vue?vue&type=script&lang=js"
import style0 from "./ProgressLegend.vue?vue&type=style&index=0&id=7bf72344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf72344",
  null
  
)

export default component.exports